import React from "react";
import {Card,CardBody} from "reactstrap";

function EmptyData(props) {
  return (
    <Card
      className="mb-4"
      style={{
        display: "flex",
        flex: 1,
        marginTop:"5px",
        textAlign: "center",
        justifyContent: "center",
        padding: "1.25rem 1.5rem",
      }}
    >
      <CardBody>
        <h1 className="mb-0">No Records Found!</h1>
        </CardBody>
        </Card>
  );
}

export default EmptyData;
